import { CSSProperties } from "react"

export enum Action {
  add = 'add',
  delete = 'delete',
  preview = 'preview',
  clear = 'clear',
  subscribePreview = 'subscribe-preview'
}

interface GeometryOptions {
  units?: 'Meters' | 'Millimeters' | 'Feet' | 'Inches' | 'Centimeters',
}

export interface SendGeometryProps {
  geometry?: string[]
  defaultAction?: Action
  defaultKey?: string
  optionsConfig?: { [index in Action]: boolean }
  geometryOptions?: GeometryOptions
  onOverlayHeightChange?: (height: number) => any
}
